<div class="mt-5">
  <div class="flex justify-content-between">
    <div class="g-c-primaryDarkerColor font-bold text-lg">
      {{'submission_review'|translate}}
    </div>
  </div>
  <div class="mt-5">
    <p-table [class]="dir" [dir]="dir" [value]="criterias" [tableStyle]="{ 'min-width': '50rem' }">
      <ng-template pTemplate="header">
        <tr>
          <th>
            {{'criteria'|translate}}

          </th>
          <th>
            {{'value'|translate}}

          </th>

          <th [pSortableColumn]="'score'">
            {{'score'|translate}}
            <p-sortIcon></p-sortIcon>
          </th>
          <th>
            {{'notes'|translate}}
          </th>

          <th>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-submission>
        <tr>
          <td>
            @if(dir=="rtl"){
            {{submission.name_ar}}
            }@else{
            {{submission.name_en}}
            }
          </td>
          <td class="text-green-500 font-bold ">
            {{submission.maxScore}}
          </td>
          <td>
            <p-dropdown 
              [options]="scoreOptions" 
              [(ngModel)]="submission.score"
              (onChange)="reCalculate()"
              placeholder="اختر"
              appendTo="body"
              [style]="{'width': '5rem', 'text-align': 'center'}">
            </p-dropdown>
          </td>
          <td>
            <textarea rows="3" cols="15" [(ngModel)]="submission.notes" pInputTextarea></textarea>
          </td>
          <td>

          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="footer">
        <tr>
          <td class="text-center" colspan="">
            {{'total_score'|translate}}
          </td>
          <td></td>
          <td>
            <div class="flex justify-content-center align-items-center">
              <div class="text-xl font-bold g-c-primary">
                {{finalScore}}
              </div>
            </div>
          </td>
          <td>
          </td>

          <td>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <form #reasonForm="ngForm">
    <div class="mt-5">
      <div class="mb-2 g-c-primaryDarkColor font-bold">
        <label>{{'describe_reasons' | translate}}</label>
      </div>
      <textarea pInputTextarea #reasons_ref_native #reasons_ref="ngModel" required [(ngModel)]="reasons" rows="3"
        name="reasons"></textarea>
      @if((reasons_ref.invalid&&
      reasons_ref.touched)||(reasons_ref.invalid &&isSubmitted ))
      {
      <div class="text-red-500">
        الحقل مطلوب
      </div>
      }
    </div>

  </form>
  @if(isSuccessModalVisible){
  <app-success-modal message="أُرسل التقييم بنجاح"></app-success-modal>
  }

</div>